module.exports = __webpack_public_path__ + "img/no-scenes.a6c01c81.png";